export const editWorkersFormStyles = {
  container: {
    p: 2,
  },
  chipsContainer: {
    flexDirection: 'row',
    gap: 1,
    flexWrap: 'wrap',
  },
  chip: {
    margin: 0,
  },
};
